import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeftIcon, SearchIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { MOCK_VIDEOS, MOCK_USERS } from '../data/mockData';
import { Avatar } from '../components/ui/Avatar';
import { FollowButton } from '../components/ui/FollowButton';
export function SearchResults() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const query = queryParams.get('q') || '';
  const [activeTab, setActiveTab] = useState('Videos');
  const tabs = ['Videos', 'Users', 'Hashtags'];
  return <div className="w-full h-full bg-black flex flex-col" data-id="element-543">
      {/* Header */}
      <div className="px-4 pt-6 pb-2 bg-black z-10" data-id="element-544">
        <div className="flex items-center gap-3 mb-4" data-id="element-545">
          <button onClick={() => navigate(-1)} className="text-white hover:text-softGray transition-colors" data-id="element-546">
            <ArrowLeftIcon size={24} data-id="element-547" />
          </button>
          <div onClick={() => navigate('/search')} className="flex-1 bg-surface border border-border rounded-full py-2 pl-4 pr-4 flex items-center gap-2 text-white cursor-text" data-id="element-548">
            <SearchIcon size={16} className="text-softGray" data-id="element-549" />
            <span className="text-sm truncate" data-id="element-550">{query}</span>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex border-b border-border" data-id="element-551">
          {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className="flex-1 pb-3 relative" data-id="element-552">
              <span className={`text-sm font-bold transition-colors ${activeTab === tab ? 'text-white' : 'text-softGray'}`} data-id="element-553">
                {tab}
              </span>
              {activeTab === tab && <motion.div layoutId="searchTabIndicator" className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary" data-id="element-554" />}
            </button>)}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto no-scrollbar" data-id="element-555">
        {activeTab === 'Videos' && <div className="grid grid-cols-2 gap-1 px-1 py-1" data-id="element-556">
            {MOCK_VIDEOS.map(video => <div key={video.id} className="relative aspect-[3/4] bg-surface rounded-md overflow-hidden cursor-pointer" data-id="element-557">
                <div className={`absolute inset-0 bg-gradient-to-br ${video.color} opacity-80`} data-id="element-558" />
                <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/80 to-transparent" data-id="element-559">
                  <p className="text-white/90 text-[10px] line-clamp-2 leading-tight mb-1" data-id="element-560">
                    {video.caption}
                  </p>
                  <div className="flex items-center gap-1 text-softGray text-[10px]" data-id="element-561">
                    <span data-id="element-562">❤️ {video.likes}</span>
                  </div>
                </div>
              </div>)}
          </div>}

        {activeTab === 'Users' && <div className="p-4 space-y-4" data-id="element-563">
            {MOCK_USERS.map(user => <div key={user.id} className="flex items-center justify-between" data-id="element-564">
                <button onClick={() => navigate('/profile')} className="flex items-center gap-3 flex-1 text-left hover:opacity-90 transition-opacity" data-id="element-565">
                  <Avatar src={user.avatar} size="lg" data-id="element-566" />
                  <div data-id="element-567">
                    <h3 className="text-white font-bold text-sm" data-id="element-568">
                      {user.username}
                    </h3>
                    <p className="text-softGray text-xs" data-id="element-569">
                      {user.name} • {user.followers} followers
                    </p>
                  </div>
                </button>
                <FollowButton data-id="element-570" />
              </div>)}
          </div>}

        {activeTab === 'Hashtags' && <div className="p-4 space-y-4" data-id="element-571">
            {['comedy', 'standup', 'pranks', 'funny'].map(tag => <div key={tag} className="flex items-center gap-4 cursor-pointer group" data-id="element-572">
                <div className="w-12 h-12 rounded-full bg-surface flex items-center justify-center text-white font-bold text-xl border border-border group-hover:border-primary transition-colors" data-id="element-573">
                  #
                </div>
                <div data-id="element-574">
                  <h3 className="text-white font-bold text-sm group-hover:text-primary transition-colors" data-id="element-575">
                    #{tag}
                  </h3>
                  <p className="text-softGray text-xs" data-id="element-576">
                    {(Math.random() * 100).toFixed(1)}M views
                  </p>
                </div>
              </div>)}
          </div>}
      </div>
    </div>;
}